<template>
  <section class='not-found'>
    <div class="flex-wrapper">
      <div class="content">
        <div class="content-wrap">
          <div class="group">
            <router-link
                class="menu-link"
                :to="{name: 'public.login'}"
            >
              <img :src="logo" alt="Broodje dunner logo">
            </router-link>
          </div>

          <div class="group">
            <h3>Pagina niet gevonden</h3>
          </div>
          <p>
            De pagina die je probeert te bereiken bestaat niet (meer). Klik op de knop hieronder om terug te
            gaan naar home.
          </p>

          <router-link
              class='btn wide'
              :to='{name: "public.login"}'
          >
            Terug naar home
          </router-link>
        </div>
      </div>

      <div class="image">
        <img :src="image" alt="Login image for Broodje Dunner">
      </div>
    </div>
  </section>
</template>

<script>
import background from "@/assets/images/login-background.jpeg";
import logo from "@/assets/images/logo.svg";

export default {
  name: "Not Found",
  data() {
    return {
      image: background,
      logo: logo
    }
  },
};
</script>
